import { routes } from 'pages/Routes'
import { routeMatcher } from "lib/components/router/routeMatcher";

class UrlHelper {

    public get queryParams() {
        const urlSearchParams = new URLSearchParams(window.location.search);
        return Object.fromEntries(urlSearchParams.entries());
    }

    get isTeacherClassroomPreview() {
        const matchResult = routeMatcher(routes.TeacherClassroom).match(window.location.pathname);
        if (!matchResult.matches) {
            return false;
        }
        return this.queryParams.preview !== undefined;
    }

    get isTeacherClassroomHomework() {
        const matchResult = routeMatcher(routes.TeacherClassroom).match(window.location.pathname);
        if (!matchResult.matches) {
            return false;
        }
        return this.queryParams.homework !== undefined;
    }
}

export const urlHelper = new UrlHelper();
